<!--拷贝库存调拨单-->
<template>
  <SelectTableDialog
    :title="$t('logistics.stockOrderTable.allot')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    :extraData="extraData"
    :confirmUnchecked="false"
    :isMultiple="false"
    width="1200px"
    @close="close"
    @confirm="creatOrder"
  >
  </SelectTableDialog>
</template>

<script>
  import { mapState } from 'vuex';
  import SelectTableDialog from '@/components/SelectTableDialog';
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'stockOrderTable',
    components: {
      SelectTableDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            prop: 'allotNo',
            name: this.$t('logistics.stockOrderTable.allotNo'),
            type: 'input',
          },
          {
            prop: 'allotDateBegin',
            name: this.$t('logistics.stockOrderTable.allotDateBegin'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'allotDateEnd',
            name: this.$t('logistics.stockOrderTable.allotDateEnd'),
            type: 'endDaterangePicker',
          },
          // 部门
          {
            prop: 'allotDepartmentNo',
            name: this.$t('logistics.returnOrderTable.returnDepartmentCode'),
            type: 'treeSelect',
            apiUrl: BASEAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
            },
            isName: false,
            clearable: false,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('logistics.stockOrderTable.searchTableSpec'),
            prop: 'allotInStorageNo',
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
          },
          {
            prop: 'compareLessZeroFlag',
            name: this.$t('logistics.logisticsReceiptList.compareLessZeroFlag'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
          {
            prop: 'compareEqualZeroFlag',
            name: this.$t('logistics.logisticsReceiptList.compareEqualZeroFlag'),
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
        ];
      },
      columnList() {
        return [
          { prop: 'allotNo', label: this.$t('logistics.stockOrderTable.allotNo') },
          { prop: 'productName', label: this.$t('logistics.returnOrderTable.productDesc') },
          { prop: 'partnerName', label: this.$t('logistics.returnOrderTable.partnerName') },
          { prop: 'allotOutAmount', label: this.$t('logistics.returnOrderTable.returnQuantity') },
          {
            prop: 'remainingNumber',
            label: this.$t('logistics.searchTable.remainingQuantityIn'),
          },
          { prop: 'allotInStorage', label: this.$t('logistics.stockOrderTable.searchTableSpec') },
          {
            prop: 'allotDepartmentName',
            label: this.$t('logistics.returnOrderTable.returnDepartmentCode'),
          },
          {
            prop: 'nameVoyageLicense',
            label: this.$t('logistics.stockOrderTable.nameVoyageLicense'),
          },
          { prop: 'allotDate', label: this.$t('logistics.stockOrderTable.allotDate') },
        ];
      },
    },
    data() {
      return {
        defaultVisible: false,
        API: API.LIST_STORAGE_ALLOST,
        extraData: {
          allotStatus: '3', //调拨完成状态
          inIsDirectDeliver: '0',
        },
      };
    },
    methods: {
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      //跳转编辑页
      creatOrder(selections) {
        if (selections.length !== 0 && selections[0]) {
          this.defaultVisible = false;
          let path = {
            path: '/logistics/logisticsRevise',
            name: 'logisticsRevise',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsRevise.logisticsRevise'),
            },
            query: {
              allotNo: selections[0].allotNo,
              number: '4',
              inboundType: 'RK02', //调拨
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.$message({
            message: this.$t('logistics.stockOrderTable.creatTranstionOrder'),
            type: 'error',
          });
        }
        // else if (selections.length>1) {
        //   this.$message({
        //     message: "不可合并创建",
        //     type: "error"
        //   });
        // }
      },
    },
  };
</script>
